import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getDonates} from '../actions/MainAction';
export class DonatesPage extends Component {
  
  openModal=(data, lang, lang_id=1)=>{
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        image: data?.image?data?.image:"",
        image_full_url: data?.image_full_url?data?.image_full_url:"",
        icon: data?.icon?data?.icon:"",
        icon_full_url: data?.icon_full_url?data?.icon_full_url:"",
        num_1: data?.num_1?data?.num_1:"",
        num_2: data?.num_2?data?.num_2:"",
        num_3: data?.num_3?data?.num_3:"",
        languages:
          {
            id:lang?.id?lang?.id:'',
            title:lang?.title?lang?.title:'',
            text:lang?.text?lang?.text:'',
            lang_id:lang_id
          }
        ,
        requiredsLang: ["title"],
        requireds:[],
        afterCallFunction:this.props.getDonates,
        afterParams:[],
        url:'admin-donates'
      }
    })
  }

  componentDidMount(){
    this.props.getDonates();
  }
  render() {
    const {donatesData} = this.props;
    return (
      <div className='p-[40px] w-full'>
        <Header onClickBtn={this.openModal.bind(this, "", "", 1)} title="Donates" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
          {
            donatesData?.map((data, i)=>{
              return(
                <Card1 
                  key={i}
                  image={data?.image_full_url}
                  video={data?.video_full_url}
                  onChangeLang={(id)=>this.openModal(data, data.translates.find(x=>x.lang_id==id), id)} 
                  title1={data?.translate?.title}
                  deleteUrl={`admin-donates/${data?.id}`}
                  afterCallFunction={()=> this.props.getDonates()}
                />
              )
            })
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  donatesData: state.Data.donatesData,
});
const mapDispatchToProps = {changeStateValue, getDonates}
export default connect(mapStateToProps, mapDispatchToProps)(DonatesPage)
 
 
